import { render } from "./forcemajeure.vue?vue&type=template&id=631696d9&scoped=true"
import script from "./forcemajeure.vue?vue&type=script&lang=js"
export * from "./forcemajeure.vue?vue&type=script&lang=js"

import "./forcemajeure.vue?vue&type=style&index=0&id=631696d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631696d9"]])

export default __exports__